import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {
  ALERT_VIEW_WARNING,
  ALERT_VIEW_WARNING_HEADER,
} from "../../../utils/GlobalMessageConstants";
import {
  CANCEL_IMPORT_LABEL,
  CANCEL_SURVERY_LABEL,
  CONTINUE_IMPORT_LABEL,
  CONTINUE_SURVERY_LABEL,
} from "../../../utils/GlobalConstants";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function AlertDialog(props) {
   const { t } = useTranslation();
   
  return (
    <React.Fragment>
      <Dialog
        open={props.isOpen}
        onClose={props.handleCloseAlertView}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        data-testid="alert-dialog"
      >
        <DialogTitle id="alert-dialog-title" data-testid="dialog-title">
         
          Warning
        </DialogTitle>
        <DialogContent data-testid='dialog-content'>
          <DialogContentText id="alert-dialog-description">
            {props.valid ==='year$vin' && 
            <div><span data-testid='alert-head'>{ALERT_VIEW_WARNING_HEADER}</span>
            <div>
            {props?.vinStatus?.map((item, index)=>
            <Box data-testid={`vin-message-${index}`} key={item?.vin}> <span>VIN: {item?.vin} -{item?.message}</span></Box>)}
           </div>
            {ALERT_VIEW_WARNING}</div>
}

         {props.valid ==='year' && 
            <div><span  data-testid='alert-headY'>{ALERT_VIEW_WARNING_HEADER}</span>
            <span data-testid='alert-heady2'>{ALERT_VIEW_WARNING}</span></div>
}
        {props.valid ==='vin' && props?.vinStatus && props?.vinStatus?.length>0 && 
            <div> <div><h4>Vin Validation</h4></div>{props?.vinStatus?.map((item, index)=> <Box key={item?.vin} data-testid={`vin-message-${index}`}><span>Vin - {item?.vin} -{item?.message}</span></Box>)}</div>
}
{props?.isPart && <div> <div><h4>Parts</h4></div><Box><span> {t("tab2.contents.messages.partValidationMsg")}</span></Box></div>}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {!props?.isImportOnly ? 
          <Button data-testid="cancel-button" className="button-style" onClick={props.handleCloseAlertView}>
            {props?.isSurvery? CANCEL_SURVERY_LABEL:CANCEL_IMPORT_LABEL}
          </Button>:''}
          <Button
          data-testid="continue-button"
            className="button-style margin5"
            onClick={props.handleImport}
            autoFocus
          >
            {props?.isSurvery? CONTINUE_SURVERY_LABEL:CONTINUE_IMPORT_LABEL}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
